/**
`com-calendar-base`
  - This is private component that should not be directly used.  All clients should use com-calendar component
@demo demo/index.html
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { COMUtils } from '@com/utils';
import { PolymerElement, html } from '@polymer/polymer';
import './style/com-calendar-base-style.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';

import '@polymer/polymer/lib/elements/dom-if.js';
import '@polymer/polymer/lib/elements/dom-repeat.js';
import '@polymer/iron-a11y-keys/iron-a11y-keys.js';
import { GestureEventListeners } from '@polymer/polymer/lib/mixins/gesture-event-listeners.js';

import { COMCalendarBehavior } from  './com-calendar-behavior.js';
import './com-calendar-date.js';
import './com-calendar-button.js';
import './com-calendar-drawer.js';

import { addListener, setTouchAction } from '@polymer/polymer/lib/utils/gestures.js';
import { beforeNextRender, afterNextRender } from '@polymer/polymer/lib/utils/render-status.js';

class COMCalendarBase extends GestureEventListeners(COMCalendarBehavior(PolymerElement)) {

  static get template() {
    return html`
    <!-- Scoped styles for this element -->
    <style include="com-theme"></style>
    <style include="com-calendar-base-style"></style>

    <!-- tap navigation header (outside of dom-repeat) -->

    <div class="calendarNav" hidden\$="[[!_hasNavigationArrows(navigation)]]">
    <h3 id="navMonthYear[[monthIndex]]" aria-live="[[calendarAriaLiveSetting]]" class="monthYearHeader" hidden\$="[[_hasNavigationSwipe(navigation)]]"><span id="monthHeader[[monthIndex]]" class="monthHeader">[[_getMonthName(currentDate, 0, locale)]]</span> <span hidden\$="[[hideYear]]" id="year[[monthIndex]]">[[_getYear(currentDate, 0, locale)]]</span></h3>
    </div>

    <div class="calendarNav" hidden\$="[[_hasNavigation(navigation)]]">
      <div id="hasNavMonthYear[[monthIndex]]" aria-live="[[calendarAriaLiveSetting]]" class="monthYearHeader"><span id="hasMonthHeader[[monthIndex]]" class="monthHeader">[[_getMonthName(currentDate, 0, locale)]]</span> <span hidden\$="[[hideYear]]" id="hasYear[[monthIndex]]">[[_getYear(currentDate, 0, locale)]]</span></div>
    </div>

    <div id="months" on-mousedown="_preventCalendarFocus">
      <template is="dom-repeat" items="[[_getMonthOffsets(navigation)]]" as="offset">
        <div class="monthWrapper" id\$="[[_calculateId('monthWrapper', offset)]]" active\$="[[_isMonthActive(offset)]]" visible\$="[[_isVisible(currentDate, startDate, endDate, offset, disableNavigation, disablePrevArrow, disableNextArrow)]]">

          <!-- a11y keyboard controls -->
          <iron-a11y-keys keys="left" on-keys-pressed="_prevDay"></iron-a11y-keys>
          <iron-a11y-keys keys="up" on-keys-pressed="_prevWeek"></iron-a11y-keys>
          <iron-a11y-keys keys="right" on-keys-pressed="_nextDay"></iron-a11y-keys>
          <iron-a11y-keys keys="down" on-keys-pressed="_nextWeek"></iron-a11y-keys>

          <!-- swipeable header -->
          <div class="calendarHeaderSwipe" hidden\$="[[!enableSwipeableHeader]]">
            <div class="monthYearHeader"><span class="monthHeader">[[_getMonthName(currentDate, offset, locale)]]</span> <span hidden\$="[[hideYear]]" class="year">[[_getYear(currentDate, offset, locale)]]</span></div>
          </div>

          <!-- weekdays and month -->
          <div class="weekdaysAndMonth">

            <div class="weekdaysHeader" hidden\$="[[_showEndMessage(currentDate, endDate, offset, _hasEndMessage)]]">
              <template is="dom-repeat" items="[[getWeekdays(locale, presentation, 0)]]">
                <div class="weekdays" role="heading" aria-hidden="true" aria-label\$="[[item.full]]"><span aria-hidden="true">[[item.abbreviation]]</span></div>
              </template>
            </div>

            <div id\$="[[_calculateId('monthContainer', offset)]]" class="month" on-com-calendar-date.selected="_onDateSelected" aria-label\$="[[_getMonthName(currentDate, offset, locale)]] [[_getYear(currentDate, offset, locale)]]">

              <!-- end message -->
              <template is="dom-if" if="[[_isEnd(currentDate, endDate, offset)]]" restamp="">
                <div id="endMessage" hidden\$="[[!_showEndMessage(currentDate, endDate, offset, _hasEndMessage)]]">
                  <slot name="endMessage" offset\$="[[offset]]"></slot>
                </div>
              </template>

              <template is="dom-if" if="[[!_showEndMessage(currentDate, endDate, offset, _hasEndMessage)]]" restamp="">
                <template id="dates" is="dom-repeat" items="[[_getMonthData(currentDate, offset, weekdayOffset, redrawFuse, useGridDisplayStyle, useSameCalendarHeight)]]" on-dom-change="_dispatchDataLoad">
                  <div class\$="[[_getDateClass(item)]]">
                    <div class="rangePadding">
                    <template is="dom-if" restamp="" if="[[item.value]]">
                      <slot class="date" on-slotchange="_updateSlottedDate" id\$="[[item.value]]" name\$="[[item.value]]">
                        <template is="dom-if" if=[[!useSimpleDateElement]]>
                          <com-calendar-date
                            presentation="[[presentation]]"
                            past="[[isPastDate(item.value, startDate)]]"
                            allow-disabled-focus="[[allowDisabledFocus]]"
                            disabled\$="[[_isDefaultDateDisabled(item.value, startDate, endDate, availableUntilEndDate, onlyEnableSlotted, disableSelection, allowDisabledFocus)]]"
                            on-mousedown="_preventFocus"
                            date="[[item.value]]"
                            enable-nav-to-disabled-dates="[[enableNavToDisabledDates]]"
                          >
                          </com-calendar-date>
                        </template>
                      </slot>
                    </template>
                    <template is="dom-if" restamp="" if="[[!item.value]]">
                      <div aria-hidden="true" class\$="[[_getBlankClass(selectedDates, selectableEndDate, item)]]">
                        <div class="dayPlaceholder"></div>
                        <div class="dateTypeIndicatorPlaceholder"></div>
                      </div>
                    </template>
                    </div>
                  </div>
                </template>
              </template>

            </div><!-- end month -->
          </div><!-- end weekdaysAndMonth -->

        </div><!-- end monthWrapper -->
      </template>
    </div>
    <div tabindex="-1" id="refocus"></div>
    <com-calendar-drawer id="drawer" role="heading" aria-label=[[ariaContent.drawerLabel]]
      open="{{drawerOpen}}" enable="[[_isDrawerEnabled()]]" animate="{{drawerAnimate}}" tabindex="0">
        <slot name="drawer" slot="drawerContent"></slot>
    </com-calendar-drawer>
`;
  }

  static get is() { return 'com-calendar-base'; }
  static get properties() {
    return {
      availableDates: {
        type: Array,
        observer: 'refreshDateElements'
      },
      /**
       * @desc calendar start date, ex: 2017-10-01
       * @type {String}
       */
      startDate: {
        type: String,
        value: function() {
          return this.getStringFromDate(new Date())
        },
        notify: true
      },
      /**
       * @desc price view
       * @type {Boolean}
       */
      disableAdditionalAriaDateLabel: {
        type: Boolean,
        value: false
      },
      /**
       * @desc clean presentation
       * @type {Boolean}
       */
      clean: {
        type: Boolean,
        reflectToAttribute: true,
        value: false
      },
      /**
       * @desc calendar end date, ex: 2017-12-31
       * @type {String}
       */
      endDate: {
        type: String
      },
      /**
       * @desc selected calendar date, ex: 2017-10-20
       * @type {String}
       */
      selectedDate: {
        type: String,
        notify: true
      },
      /**
       * @desc Cookie properties for locale.
       * This needs to be set before calling getLocale().
       * @type {Object}
       */
      _localeFields: {
        type: Object,
        value: {
          cookieName: 'languageSelection_jar_aka',
          propertyName: 'preferredLanguage'
        }
      },
      /**
       * @desc locale used for year, month, day labels
       * @type {String}
       */
      locale: {
        type: String,
        reflectToAttribute: true,
        computed: 'getLocale()'
      },
      /**
       * @desc cursor for current display month
       * @type {String}
       */
      currentDate: {
        type: String,
        notify: true
      },
      /**
       * @desc presentation
       * @type {String}
       */
      presentation: {
        type: String,
        value: 'regular',
        reflectToAttribute: true
      },
      /**
       * @desc navigation
       * @type {String}
       */
      navigation: {
        type: String,
        value: 'tap',
        reflectToAttribute: true
      },

      /**
       * @desc swipe month slivers
       * @type {Boolean}
       */
      slivers: {
        type: Boolean,
        value: false
      },

      ariaContent: {
        type: Object,
        value: {
          dateDefault: '',
          dateDisabled: 'not selectable',
          dateSelected: 'selected',
          youCanSelect: "You can select [pendingDays] more days from [ariaFirstDate] to [ariaLastDate]",
          selectedParkDays: "Selected, [selectedDates] of [maxAllowed] Park Reservation Days,",
          maxDaysSelected: "Maximum number of days selected, to select another day, first unselect a previous selection.",
          dateSelectable: 'in selectable range',
          navigationNextMonth: 'next month',
          navigationPrevMonth: 'previous month',
          navigationDisabled: 'not selectable',
          blockedOut: 'Blocked Out',
          noInformationAvailable: 'no information available'

        }
      },

      /**
       * @desc display content
       * @type {Object}
       */
      displayContent: {
        type: Object,
        value: {
          errorMessages: {
            maxNumberDaysReached: {
              type: "warning",
              message: "{You have reached your maximum number of days. To select another date, please adjust your number of days or deselect a date above.}",
              icon: "&#57920;",
              focus: true
            },
            badWindow: {
              type: "error",
              message: "{Your ticket must be used within [allowedDayRange] days of your first visit. There are not enough available days in this window. Please select a different starting date.}",
              icon: "&#57920;",
              focus: true
            }
          }
        }
      },
      /**
      * @desc animate
      * @type {Boolean}
      */
      animate: {
        type: Boolean,
        value: false
      },
      /**
       * @desc animate selection of date
       * @type {Boolean}
       */
      selectedDateAnimation: {
        type: Boolean,
        value: false
      },
      /**
       * @desc enable only dates that are slotted in by consumer
       * @type {Boolean}
       */
      onlyEnableSlotted: {
        type: Boolean,
        value: false
      },
      /**
       * @desc drawer enable state
       * @type {Boolean}
       */
      drawerEnable: {
        type: Boolean,
        value: false
      },
      /**
       * @desc drawer open state
       * @type {Boolean}
       */
      drawerOpen: {
        type: Boolean,
        value: false
      },
      /**
       * @desc drawer animate state
       * @type {Boolean}
       */
      drawerAnimate: {
        type: Boolean,
        value: false
      },
      /**
       * @desc if calendar has an end message
       * @type {Boolean}
       */
      _hasEndMessage: {
        type: Boolean,
        value: false
      },
      /**
       * @desc internal property used to determine how drawer moves
       * @type {Object}
       */
      _rowInfo: {
        type: Object,
        computed: '_getNumberOfDateRows(currentDate, navigation)',
        observer: '_moveDrawer'
      },
      /**
       * @desc if calendar navigation is disabled
       * @type {Boolean}
       */
      disableNavigation: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      /**
       * @desc if calendar selection is disabled
       * @type {Boolean}
       */
      disableSelection: {
        type: Boolean,
        value: false
      },
      /**
       * @desc allow focus on disabled dates to allow guests to read info only calendars
       * @type {Boolean}
       */
      allowDisabledFocus: {
        type: Boolean,
        value: false
      },
      /**
       * @desc loading
       * @type {Boolean}
       */
      loading: {
        type: Boolean,
        value: false
      },
      /**
       * @desc redraw fuse
       * @type {Boolean}
       */
      redrawFuse: {
        type: Boolean,
        value: false
      },
      /**
       * @desc hide year
       * @type {Boolean}
       */
      hideYear: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Flag to disable resetting current date when start date changes
       * @type {Boolean}
       */
      disableCurrentDateReset: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Flag to enable track gesture in months
       * @type {Boolean}
       */
      enableTrack: {
        type: Boolean,
        value: true,
        reflectToAttribute: true
      },
      /**
       * @desc enable header for swipe
       * @type {Boolean}
       */
      enableSwipeableHeader: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      /**
       * @desc disable override for com-calendar-date aria label
       * @type {Boolean}
       */
      disableOverrideAriaLabel: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Check to disable non-slotted values using slot property of com-calendar-date
       *   - flag to resolve IE issue, should be enabled by default once regression tests performed
       * @type {Boolean}
       */
      disableDatesBySlotValueCheck: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Enable the focus on drawer after the user selects a date
       * @type {Boolean}
       */
       autoFocusDrawer: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Offset for shifting weekday labels and calendar days to the left
       * @type {Number}
       */
       weekdayOffset: {
        type: Number,
        value: 0
      },
      /**
       * @desc set if prev month is enabled by month and not dates.
       * @type {Boolean}
       */
      allowPrevValidationByMonth: {
        type: Boolean,
        value: false
      },
      /**
       * @desc The Array of dates that start from the selectedDate to the selectableEndDate, excluding the disabled dates
       * @type {Array}
       */
      selectedDates: {
        type: Array,
        value: [],
        observer: '_onSelectedDatesChanged'
      },
      /**
       * @desc Check to allow to select a range of dates
       * @type {Boolean}
      */
      multipleSelect: {
        type: Object
      },
      /**
       * @desc Last date with availability data, ex: 2020-01-20
       * @type {String}
      */
      availableEndDate: {
        type: String
      },
      /**
       * @desc Check to allow selectable dates until endDate
       * @type {Boolean}
      */
      availableUntilEndDate: {
        type: Boolean,
        value: false
      },
      /**
       * @desc The selected end date for the date range
       * @type {String}
      */
      selectableEndDate: {
        type: String,
        notify: true
      },
      /**
       * @desc Check if the date range selection has been started
       * @type {Boolean}
      */
      startDateRange: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Whether or not to animate the month/year header
       * @type {Boolean}
       */
      disableAnimateMonthYear: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Flag to enable fuse
       * @type {Boolean}
       */
      enableFuse: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Flag to indicate if calendar should enable the disable dates with accessibility label
       * @type {Boolean}
       */
      enableNavToDisabledDates: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Flag to indicate if calendar should enable the past dates with accessibility label
       * @type {Boolean}
       */
       enableNavToPastDates: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Object that contains start  and end date
       * i.e { start: YYYY-MM-DD, end: YYYY-MM-DD }
       * @type {Object}
       */
      fuseDates: {
        type: Object,
        observer: '_onfuseDatesChanged'
      },
      maxAllowed: {
        type: Number,
        value: 3
      },
      allowedDayRange: {
        type: Number,
        value: 1
      },
      disablePrevArrow: {
        type: Boolean,
        value: false
      },
      disableNextArrow: {
        type: Boolean,
        value: false
      },
      propogateNavEvents: {
        type: Boolean,
        value: false
      },
      prevStartDate: {
        type: String
      },
      nextMonthOffset: {
        type: Number,
        value: 0
      },
      /**
       * @desc Determine if we should use the grid display
       * @type {Boolean}
       */
      useGridDisplayStyle: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Determine if we should show calendars with same amount of rows for side by side calendars.
       * @type {Boolean}
       */
       useSameCalendarHeight: {
        type: Boolean,
        value: false
      },
      /**
       * @desc Setting for the aria-live on calendar dates
       * available options: 'polite', 'assertive', 'off'
       * @type {String}
       */
      calendarAriaLiveSetting: {
        type: String,
        value: 'polite'
      },
      /**
       * @desc Flag to indicate if simple (non-interactive) date element should be used instead of com-calendar-date
       * (enables faster load of large calendars)
       * NOTE: The simple date element does NOT support price view at the moment
       * @type {Boolean}
       */
       useSimpleDateElement: {
        type: Boolean,
        value: false
      },

      /**
       * @desc Allow to reset selected range to be adjusted when max allowed is reached
       *   - To be used for date range picker
       */
      resetRangeOnMaxReached: {
        type: Boolean,
        value: false
      },
      /**
       * @desc index to add to the id of the com-calendar-base
       * @type {number}
       */
      monthIndex: {
        type: Number,
        value: 0
      }
    };
  }

  ready() {
    super.ready();

    this._changeDrawerState(this.selectedDates);

    addListener(this.$.months, 'track', this._trackHandler);
    setTouchAction(this.$.months, 'pan-y');
  }

  _onfuseDatesChanged() {
    this.redrawFuse = true;
  }
  /**
   * @desc property observers
   */
  static get observers() {
    return [
      // disable/enable navigation controls
      '_updateDateElements(startDate, currentDate, presentation, navigation, locale, loading)',
      '_checkHasEndMessage(currentDate)',
      '_setCurrentDateFromStartDate(startDate)'
    ];
  }

  /**
   * @return {Boolean} true if the calendar is in single day mode
   */
  _isSingleDayMode() {
    return this.maxAllowed === 1;
  }

  /**
   * @desc set currentDate when provided a startDate
   *   - currentDate does not get set to start date if disableCurrentDateReset is true
   *     and current date has been already initialized by the client
   * @param {String} startDate
   */
  _setCurrentDateFromStartDate(startDate) {
    if (!startDate || (this.disableCurrentDateReset && !!this.currentDate)) return;
    this.currentDate = startDate;
  }

  /**
   * @desc calendar listens for custom event emitted by the date tapped, sets the date selected
   * @param {Event} event
   */
  _onDateSelected(event) {
    let dateClicked = event.detail.date;
    let selectedDates = this.selectedDates ? this.selectedDates : [];
    let notifyType = 'com-calendar.selection-updated';
    let error;

    // remove from selected dates if selected date was clicked
    if (selectedDates.indexOf(dateClicked) >= 0) {
      let previousFirstSelectedDate = selectedDates[0];
      selectedDates = selectedDates.filter(selectedDate => selectedDate !== dateClicked);

      // after deselecting the first date on selected dates, if the resulting window is invalid, show error message
      if ((!this._isSingleDayMode() && selectedDates.length > 0 && dateClicked === previousFirstSelectedDate && !this._isValidWindowFor(selectedDates[0]))
          || (this._isUnavailableDate(dateClicked))) {
        notifyType = 'com-calendar.errors-warnings';

        let replacements = {
          keys: ['[allowedDayRange]'],
          values: [this.allowedDayRange]
        };
        error = this._getErrorForKey("badWindow", replacements);
      }
    // add to selected dates
    } else if (selectedDates.length < this.maxAllowed) {
      // If no dates selected yet and the window is invalid
      // the date will not be selected and an alert message will appear above the calendar.
      if (!this._isSingleDayMode() && selectedDates.length === 0 && !this._isValidWindowFor(dateClicked)) {
        notifyType = 'com-calendar.errors-warnings';

        let replacements = {
          keys: ['[allowedDayRange]'],
          values: [this.allowedDayRange]
        };
        error = this._getErrorForKey("badWindow", replacements);
      } else {
        selectedDates.push(dateClicked);
        if (this._isUnavailableDate(dateClicked)) {
          notifyType = 'com-calendar.errors-warnings';

          let replacements = {
            keys: ['[allowedDayRange]'],
            values: [this.allowedDayRange]
          };
          error = this._getErrorForKey("badWindow", replacements);
        }
      }
    } else if (this.maxAllowed === 1) {
      selectedDates = [dateClicked];
    // Set last element as date clicked if reset range on max flag is on
    // designed to be used for generic range picker
    } else if (this.resetRangeOnMaxReached) {
      selectedDates.pop();
      selectedDates.push(dateClicked);
    } else {
      notifyType = 'com-calendar.errors-warnings';
      error = this._getErrorForKey("maxNumberDaysReached");
    }

    selectedDates.sort();

    this._updateSelectedDates(selectedDates, notifyType, dateClicked, error);
    this._changeDrawerState(selectedDates);
  }

  /**
   * @desc Builds an error object with type, message and icon properties according to the provided errorKey
   * @param {String} errorKey key to fetch the error info from content
   * @param {Object} replacements if provided, a replaceTokenKeys operation will be performed over the error.message
   * with the keys and values on replacements object.
   * @return {Object} error object with type (error/warning), message and icon.
   */
  _getErrorForKey(errorKey, replacements) {
    if (!this.displayContent && !this.displayContent.errorMessages && !this.displayContent.errorMessages[errorKey]) return;

    let error = this.displayContent.errorMessages[errorKey];

    if (!error) return;

    let errorMessage = error.message;
    if (replacements) {
      errorMessage = COMUtils.replaceTokenKeys(replacements.keys, replacements.values, error.message);
    }

    return {
      type: error.type,
      message: errorMessage,
      icon: error.icon,
      focus: error.focus
    };
  }

  /**
   * @desc If a Guest attempts to select a date that results in a window that has too few days
   * for their ticket (maxAllowed)
   */
  _isValidWindowFor(startDate) {
    let selectableEndDate = this._getSelectableEndDate(startDate);
    let endDate = this.endDate;

    let dates = this.availableDates.filter(function(date) {
      return date.date >= startDate && date.date <= selectableEndDate && !date.disabled;
    });

    let availableDaysInWindow = dates.length;

    return availableDaysInWindow >= this.maxAllowed;
  }

  /**
   * @desc Check if there is available window for selectedDate and
   * check if selectedDate is between the range of selectedDates
   */
  _isUnavailableDate(selectedDate) {
    return (!this._isValidWindowFor(this.selectedDates[0])
      && this.selectedDates[0] < selectedDate
      && this.selectedDates[this.selectedDates.length - 1] >= selectedDate);
  }

  /**
   * @desc Send event on selected dates change
   * @param {String} selectedDates
   */
  _onSelectedDatesChanged(selectedDates) {
    this._updateSelectedDates(selectedDates, 'com-calendar.selection-updated');
  }

  /**
   * @desc update the calendar according to the selected date
   * @param {String} date
   * @param {String} notifyType
   */
  _updateSelectedDates(selectedDates, notifyType, lastDateSelected, error) {

    this.selectedDates = selectedDates;
    if (selectedDates && selectedDates.length > 0) {
      // find selectable end date
      this.selectableEndDate = this._getSelectableEndDate(selectedDates[0]);
    } else {
      this.selectableEndDate = '';
    }

    this.dispatchEvent(new CustomEvent(notifyType, {
      composed: true,
      bubbles: true,
      detail: {
        selectedDates: this.selectedDates,
        startDate: this.startDate,
        lastDateSelected: lastDateSelected,
        error: error
      }
    }));

    this._updateDateElements(
      this.startDate, this.currentDate, this.presentation, this.navigation,
      this.locale, this.loading
    );
  }

  /**
   * @desc Selectable end date from the specified date
   * @param {String} startDate Date from wich to get the selectable end date
   */
  _getSelectableEndDate(startDate) {
    if (startDate) {
      let dateObject = this.getDateObject(startDate);

      dateObject.setDate(dateObject.getDate() + this.allowedDayRange - 1);

      //Getting the Final Date available for select the End Date
      return this.getStringFromDate(dateObject);
    }
  }

  /**
   * @desc update slotted date
   * @param {Event} event
   */
  _updateSlottedDate(event) {
    let path = event.path || (event.composedPath && event.composedPath());
    if (!path) return;

    let slot = path[0];

    // @todo - check to see upgraded version of webcomponentsjs will resolve ie11 issue
    let wdatDate = (navigator && /(MSIE|Trident)/i.test(navigator.userAgent)) ?
      slot.querySelector('com-calendar-date') :
      slot.assignedNodes()[0];

    if (!wdatDate) return;

    // default is enabled, but disable if past date
    let isPast = this.isPastDate(wdatDate.date, this.startDate);
    wdatDate.past = isPast;

    // remove focus when previous month's slotted date contains a focus
    if (this.onlyEnableSlotted) {
      wdatDate.blur();

      // on-slotchange gets fired on ie11 even when date is not being slotted,
      // check by checking date value against slot value
      if (this.disableDatesBySlotValueCheck && wdatDate.slot !== wdatDate.date) {
        wdatDate.disabled = true;
        return;
      }
    }

    wdatDate.disabled = isPast || (this.disableSelection && !this.allowDisabledFocus) || wdatDate.disabled;
    if (!this.disableOverrideAriaLabel) wdatDate.ariaLabel = this._getDateLabel(wdatDate, this.locale);
  }

  /**
   * @desc Adds update selected/disabled properties on slotted content
   * Note: all dates are slotted, even those that are provided by default
   * @param {String} startDate, ex: 2017-10-20
   * @param {Date} currentDate
   * @param {String} presentation
   * @param {String} navigation
   * @param {String} locale
   * @param {Boolean} loading
   */
  _updateDateElements(startDate, currentDate, presentation, navigation, locale, loading) {
    if (!currentDate || !startDate || !navigation || !locale) return;

    // RenderStatus allows dom rendering / slot changes to occur before looking at slotted content
    beforeNextRender(this, () => {
      // Update disabled/selected properties for all dates in current view
      // Note: we can't use template bindings because some date elements come from light dom.
      let daysArray = this._getDays();

      daysArray.forEach(elem => {
        // set tabindex attribute to values without a class
        if (elem.classList.value === "" && this.enableNavToPastDates) {
          elem.setAttribute('class', 'noInfo');
          elem.setAttribute('tabindex', -1);
        }
        if (!this.disableOverrideAriaLabel) elem.ariaLabel = this._getDateLabel(elem, locale);
        if (elem.past) {
          if (elem.selected) {
            elem.selected = false;
            elem.setAttribute('aria-selected', false);
            elem.removeAttribute('focused');
            elem.blur();
          } else if (elem.focused) {
            elem.removeAttribute('focused');
            elem.blur();
          }
          return;
        }

        let prevDisabledState = !elem.allowDisabledFocus &&
          (elem.classList.contains('none') ||
          elem.classList.contains('unavailable') ||
          elem.classList.contains('blocked') ||
          elem.classList.contains('no-reservations') ||
          elem.classList.contains('noInfo')
        );

        elem.disabled = prevDisabledState;
        //setting the tabindex = 0 to allow the SR reading the btn
        //only if enableNavToDisabledDates is true
        if( (elem.classList.contains('unavailable') ||
            elem.classList.contains('blocked') ||
            elem.classList.contains('no-reservations') ||
            elem.classList.contains('none')) && this.enableNavToDisabledDates) {
              elem.setAttribute('tabindex', -1);
         }

        //cleaning the com-calendar-date highlighted components
        if (elem.classList.contains('selectable')) {
          elem.classList.remove('selectable');
          elem.classList.remove('start');
          elem.classList.remove('end');
        }

        if (elem.classList.contains('dimmed')) {
          elem.setAttribute('tabindex', 0);
          elem.classList.remove('dimmed');

           // when the user selects a valid date the dimmed class is added to all the calendar
           // we need the enableNavToDisabledDates=false because in other case we can tab on the invalid dates
          if (((elem.classList.contains('unavailable') ||
            elem.classList.contains('blocked') ||
            elem.classList.contains('no-reservations') ||
            elem.classList.contains('none'))  && !this.enableNavToDisabledDates) ||
            (elem.classList.contains('noInfo') && !this.enableNavToPastDates)) {
              elem.removeAttribute('tabindex');
          }
        }

        if (this.selectedDates && this.selectedDates.indexOf(elem.date) >= 0) {
          elem.selected = true;
          elem.setAttribute('aria-selected', true);
          elem.selectedDateAnimation = this.selectedDateAnimation;
        } else if (elem.selected) {
          elem.selected = false;
          elem.setAttribute('aria-selected', false);
          elem.removeAttribute('focused');
          elem.blur();
        } else if (elem.focused) {
          elem.removeAttribute('focused');
          elem.blur();
        }

        // Code to support fuse and selected dates on multi day
        let startDate = this.selectedDates && this.selectedDates.length > 0 ? this.selectedDates[0] : '';
        let endDate = this.selectableEndDate;

        let enableFuse = this._shouldEnableFuse();
        if (this._shouldSetFuseStartAndEndDate(enableFuse, startDate)) {
          startDate = this.fuseDates.start;
          endDate = this.fuseDates.end;
        }

        if (this.selectedDates && this.selectedDates.length > 0 && this.maxAllowed > 1 || enableFuse && this.fuseDates) {
          if (elem.date >= startDate && elem.date <= endDate) {
            elem.classList.add('selectable');

            if (elem.date === startDate) {
              elem.classList.add('start');
            }
            if (elem.date === endDate) {
              elem.classList.add('end');
            }
          } else {
            if (elem.date <= this.availableEndDate) {
              elem.classList.add('dimmed');
              elem.removeAttribute('tabindex');
              // when the user selects a valid date the dimmed class is added to all the calendar
              // we need to remove that class so the user cannot select invalid dates
              if (elem.classList.contains('unavailable') ||
                elem.classList.contains('blocked') ||
                elem.classList.contains('no-reservations') ||
                elem.classList.contains('none') ||
                elem.classList.contains('noInfo')) {
                  elem.removeAttribute('tabindex');
              }
            }
          }
        }

        elem.presentation = presentation;
        elem.navigation = navigation;
        elem.loading = loading;
      });
    });
  }

  /**
   * @desc Check to see if start and end date should be set as fuseDates
   *   - Allow start date to be set if enableFuse flag was directly set
   * @param {*} enableFuse
   * @param {*} startDate
   * @returns
   */
  _shouldSetFuseStartAndEndDate(enableFuse, startDate) {
    return enableFuse && (this.enableFuse || this.fuseDates.start === startDate);
  }

  /**
   * @desc Check if fuse should be enable / disable.
   */
  _shouldEnableFuse() {
    return (
      this.enableFuse && this.fuseDates
    )
    || (
      !this._isSingleDayMode()
      && this.fuseDates
      && this.fuseDates.preselectedDates
      && this.selectedDates
      && this.selectedDates.length === this.maxAllowed
    );
  }

  /**
   * @desc Ability to force update date elements.
   * For browsers that don't trigger `slotchange` event
   * when the element is first initialized.
   */
  refreshDateElements() {
    this._updateDateElements(
      this.startDate,
      this.currentDate,
      this.presentation,
      this.navigation,
      this.locale,
      this.loading
    );
  }

  /**
   * @desc get offsets for surrounding months for swipe navigation
   * @param {String} navigation
   * @return {Number[]} offsets
   */
  _getMonthOffsets(navigation) {
    if (this._hasNavigationSwipe(navigation)) return [-1, 0, 1];
    return [0];
  }

  /**
   * @desc determine if month is active month in viewpoint (swipe navigation)
   * @param {Number} offset, ie: -1 is previous month, 1 is next month
   * @return {Boolean}
   */
  _isMonthActive(offset) {
    return offset === 0;
  }

  /**
   * @desc create an array of dates for the display month based on the start date
   * @param {Date} current date for month data generation
   * @param {Number} offset, ie: -1 is previous month, 1 is next month
   * @param {Boolean} useGridDisplayStyle
   * @return {Object[]} monthData
   */
  _getMonthData(currentDate, offset, weekdayOffset, redrawFuse, useGridDisplayStyle, useSameCalendarHeight) {

   let monthData = [];
   let monthCopy = this.getDateObject(currentDate);
   monthCopy.setDate(1);
   monthCopy.setMonth(monthCopy.getMonth() + offset);
   let month = monthCopy.getMonth() + 1;

   let year = monthCopy.getFullYear();

   let date;
   let fullDate;

   // set leading dates from previous month
   let firstDay = this._getFirstDay(monthCopy);

   if (firstDay === 0 && weekdayOffset > 0) {
     firstDay = 7;
   }
   for (let i = weekdayOffset; i < firstDay; i++) {
     let monthItem = {value: ""};
     if (i === weekdayOffset) {
       monthItem.first = true;
     }
     monthData.push(monthItem);
   }
   // populate with days of the month
   let numberOfDays = this._getNumberOfDays(monthCopy);

   for (let i = 1; i <= numberOfDays; i++) {
     date = i.toString();
     // zero padding for date format
     month = this._getZeroPadding(month);
     date = this._getZeroPadding(date);
     // date format: YYYY-MM-DD
     fullDate = year + "-" + month + "-" + date;
     if (i === 1) {
       monthData.forEach(dateItem => {
         dateItem.adjacentValue = fullDate;
       });
     }
     monthData.push({
       value: fullDate
     })
   }

   // set trailing dates from next month
   let remainderDays = ((7 - (monthData.length % 7)) % 7);

   // if using grid display all calendars need to be same length, add extra week to bottom
   // of shorter calendar months
   if (useGridDisplayStyle && monthData.length < 36) {
    remainderDays = remainderDays + 7;
   }

   // if we have requested calendars to be same height in rows, check and equalize if neccesary.
   // it will only work on a view with 2 calendars side by side (monthsToDisplay = 2)
   // small screens (adaptive: xs) & no useGridDisplayStyle set.
   if (useSameCalendarHeight && !useGridDisplayStyle) {
    // get current calendar rows.
    const currTotalRows = (monthData.length + remainderDays) / 7;
    // copy over current month & set value tu side month.
    const sideMonth = new Date(monthCopy.valueOf());
    sideMonth.setMonth(this.id.includes('0') ? sideMonth.getMonth() + 1 : sideMonth.getMonth() - 1);
    // first day position in calendar -offset + number of days in side month.
    let sideNumOfDays = this._getFirstDay(sideMonth) - weekdayOffset + this._getNumberOfDays(sideMonth);
    // add remainder days for next calendar.
    sideNumOfDays += (7 - (sideNumOfDays % 7)) % 7;
    // get side calendar rows.
    const sideTotalRows = sideNumOfDays / 7;
    // if we have more rows in side calendar, add new row to current to equalize.
    if (currTotalRows < sideTotalRows) {
     remainderDays += 7;
    }
   }

   for (let i = 0; i < remainderDays; i++) {
     let monthItem = {value: "", adjacentValue: fullDate };
     if (i === remainderDays - 1) {
       monthItem.last = true;
     }
     monthData.push(monthItem);
   }

   for (let i = 0; i < 7; i++) {
     monthData[i].firstRow = true;
   }

   for (let i = monthData.length - 1; i >= monthData.length - 7; i--) {
     monthData[i].lastRow = true;
   }

   for (let i = 0; i < monthData.length / 7; i++) {

     let firstIndex = i * 7;
     let lastIndex = firstIndex + 6;

     monthData[firstIndex].firstWeekday = true;
     monthData[lastIndex].lastWeekday = true;
   }
   return monthData;
 }

  /**
   * @desc notify client when month data has been loaded
   */
  _dispatchDataLoad(event) {
    this.dispatchEvent(
      new CustomEvent(
        'com-calendar.month-data-loaded', {
          bubbles: true,
          composed: true,
          detail: { type: 'month-data-loaded'}
        }
      )
    );
  }

  /**
   * @desc get the month name based on locale
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
   * @param {Date} currentDate
   * @param {Number} offset, ie: -1 is previous month, 1 is next month
   * @param {String} locale
   * @return {String} month
   */
  _getMonthName(currentDate, offset, locale) {
    if (!currentDate) return;

    let dateCopy = this.getDateObject(currentDate);
    dateCopy.setDate(4);
    dateCopy.setMonth(dateCopy.getMonth() + offset);


    return this.getMonthName(dateCopy, locale)
  }

  /**
   * @desc get the year based on locale
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
   * @param {Date} currentDate
   * @param {String} locale
   * @param {Number} offset, ie: -1 is previous month, 1 is next month
   * @return {String} year
   */
  _getYear(currentDate, offset, locale) {
    if (!currentDate) return;

    let dateCopy = this.getDateObject(currentDate);
    dateCopy.setDate(1);
    dateCopy.setMonth(dateCopy.getMonth() + offset);

    if (!this._useToLocaleString) {
      return dateCopy.getFullYear();
    }

    return dateCopy.toLocaleString(locale, {year: 'numeric'});
  }

  /**
   * @desc previous arrow handler
   * @param {Event} e
   */
  _prevHandler(e) {
    if (!this._allowPrev(this.currentDate, this.startDate, this.disableNavigation, this.disablePrevArrow)) {
      if (this.propogateNavEvents) {
        this._navigationEventHandler(e, 'previous');
      }
      return;
    }

    if (this.navigation === 'tap' && this.animate !== false) {
      this._tapAnimation('previous');
    } else {
      let month = this.getDateObject(this.currentDate);
      month.setDate(1);
      month.setMonth(month.getMonth() - 1);
      this.currentDate = this.getStringFromDate(month);
    }

    this._navigationEventHandler(e, 'previous');

    this.drawerOpen = this._shouldDrawerStayOpen();
  }

  /**
   * @desc next arrow handler
   * @param {Event} e
   */
  _nextHandler(e) {
    if (!this._allowNext(this.currentDate, this.endDate, this.disableNavigation, this.disableNextArrow)) {
      if (this.propogateNavEvents) {
        this._navigationEventHandler(e, 'previous');
      }
      return;
    }

    if (this.navigation === 'tap' && this.animate !== false) {

      this._tapAnimation('next');
    } else {
      let month = this.getDateObject(this.currentDate);

      month.setMonth(month.getMonth() + 2 + this.nextMonthOffset, 0);
      this.currentDate = this.getStringFromDate(month);
    }

    if (!e.detail || !e.detail.disableEventHandle) {
      this._navigationEventHandler(e, 'next');
    }

    this.drawerOpen = this._shouldDrawerStayOpen();
  }

  /**
   * @desc `_navigationEventHandler` dispatch custom event to parent
   * @param {Event} event
   * @param {String} direction // Retreat or Advance
   * @return {Void}
   */
  _navigationEventHandler(event, direction) {
    this.dispatchEvent(new CustomEvent('com-calendar.navigation-change', {
      bubbles: true,
      composed: true,
      detail:{
        target: event.target,
        direction: direction,
        currentDate: this.currentDate
      }
    }));
  }

  /**
   * @desc Animate 3 nodes: #monthContainer, its clone, and #navMonthYear
   * @param {String} direction
   */
  _tapAnimation(direction) {
    const previous = (direction === 'previous');
    // swipeable month header
    let swipeableHeader = this.shadowRoot.querySelectorAll('.calendarHeaderSwipe')[0];
    // month year header
    let navMonthYear = this.shadowRoot.querySelectorAll('#navMonthYear')[0];
    // monthContainer
    let monthContainerNode = this.shadowRoot.querySelectorAll('#monthContainer-0')[0];

    // parent container for the month container to attach
    // #monthWrapper-0 is the wrapper with the offset of 0 and is in the center
    let parent = this.shadowRoot.querySelectorAll('#monthWrapper-0')[0];

    // clone the original
    let clone = monthContainerNode.cloneNode(true);

    // set the month to the next month
    let month = this.getDateObject(this.currentDate);
    let monthOffset = (previous) ? -1 : 2;
    if (previous) {
      month.setDate(1);
      month.setMonth(month.getMonth() + monthOffset);
    } else {
      month.setMonth(month.getMonth() + monthOffset, 0);
    }
    this.currentDate = this.getStringFromDate(month);

    parent.appendChild(clone);
    clone.classList.add('clone');

    // animate the clone
    let animateCloneClass = (previous) ? 'cloneMoveRight' : 'cloneMoveLeft';
    clone.classList.add(animateCloneClass);

    // on animationend remove clone
    clone.addEventListener('animationend', () => {
      clone.classList.remove(animateCloneClass)
      parent.removeChild(clone);
    });

    let animateNodeClass = (previous) ? 'moveRight' : 'moveLeft';
    let element = this;

    setTimeout(function() {
      if (!element.disableAnimateMonthYear) {
        navMonthYear.classList.add(animateNodeClass);
      }
      swipeableHeader.classList.add(animateNodeClass);
      monthContainerNode.classList.add(animateNodeClass);
    }, 0);

    let animationEnd = () => {
      monthContainerNode.classList.remove(animateNodeClass);

      if (!element.disableAnimateMonthYear) {
        navMonthYear.classList.remove(animateNodeClass);
      }
      swipeableHeader.classList.remove(animateNodeClass);
      monthContainerNode.removeEventListener("animationend", animationEnd);
    };
    monthContainerNode.addEventListener('animationend', animationEnd);
  }

  /**
   * @desc Prevent firing focus on calendar when clicking on disabled dates
   * @param {Event} e
   */
  _preventCalendarFocus(e) {
    let classList = e.target.classList;
    if (classList.contains('blank') || classList.contains('month') || !this._isLeftClick(e)) this._preventFocus(e);
  }

  /**
   * @desc Prevent firing focus on click
   * https://stackoverflow.com/questions/8735764/prevent-firing-focus-event-when-clicking-on-div/45131490#45131490
   * @param {Event} e
   */
  _preventFocus(e) {
    if (e.target.getAttribute('allow-disabled-focus')) return;
    e.preventDefault();
  }

  /**
   * @desc Identify left click on a mouse click event
   * https://stackoverflow.com/a/2405835/474740
   * @param {Event} e
   */
  _isLeftClick(e) {
    let isLeftClick = false;
    if ('which' in e) {  // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
      isLeftClick = e.which == 1;
    } else if ('button' in e) {  // IE, Opera
      isLeftClick = e.button == 1;
    }
    return isLeftClick;
  }

  /**
   * @desc track handler (moving while finger/button is down)
   * @see https://www.polymer-project.org/2.0/docs/devguide/gesture-events#gesture-event-types
   * @param {Event} e
   */
  _trackHandler(e) {
   e.preventDefault();
   e.stopPropagation();

   // Get component since sibling methods cannot be invoked
   let path = e.path || (e.composedPath && e.composedPath()),
     parent = path.filter(n => n.tagName === 'COM-CALENDAR-BASE')[0],
     dx = e.detail.dx;

   if (!parent.enableTrack) return;

   switch(e.detail.state) {
     case "end":
       if (parent._atThreshold(dx)) {
         if (dx > 0) {
           parent._prevHandler(e);
         } else {
           parent._nextHandler(e);
         }
       }
       break;
   }
 }

  /**
   * @desc check track position to the threshold
   * @param {Number} dx the change in x position since first track
   * @return {Boolean}
   */
  _atThreshold(dx) {
    let threshold = 30;

    return (dx > 0 && dx >= threshold) || (dx < 0 && dx <= -threshold);
  }

  /**
   * @desc determine if previous operation is allowed
   * @param {Date} current date
   * @param {String} start date
   * @param {Boolean} disable navigation
   * @return {Boolean}
   */
  _allowPrev(currentDate, startDate, disableNavigation, disablePrevArrow) {
    if (disableNavigation || disablePrevArrow) return false;

    let useStartDate = (this.prevStartDate) ? this.prevStartDate : startDate;
    const isSameDate = this.isSameDate(currentDate, useStartDate);

    return currentDate > useStartDate && !isSameDate;
  }

  /**
   * @desc determine if next operation is allowed
   * @param {String} current date
   * @param {String} end date
   * @param {Boolean} disable navigation
   * @return {Boolean}
   */
  _allowNext(currentDate, endDate, disableNavigation, disableNextArrow) {
    if (disableNavigation || disableNextArrow) return false;
    const isSameDate = this.isSameDate(currentDate, endDate);
    if (!endDate) return true;
    return currentDate < endDate && !isSameDate;
  }

  /**
   * @desc set navigation arrows' disabled states based on startDate and endDate
   * @param {Date} currentDate
   * @param {String} startDate, ex: 2017-10-01
   * @param {String} endDate, ex: 2017-12-31
   */
  _setNavigation(currentDate, startDate, endDate, disableNavigation, disablePrevArrow, disableNextArrow) {
    if (!currentDate) return;

    let ariaNextMonthText = this.ariaContent.navigationNextMonth,
      ariaPreviousMonthText = this.ariaContent.navigationPrevMonth,
      ariaDisabledText = this.ariaContent.navigationDisabled;

    let allowPrev = this._allowPrev(currentDate, startDate, disableNavigation, disablePrevArrow);
    let allowNext = this._allowNext(currentDate, endDate, disableNavigation, disableNextArrow);

    this.$.prevArrow.disabled = !allowPrev;
    this.$.nextArrow.disabled = !allowNext;

    const prevMonthText = allowPrev ? ariaPreviousMonthText : ariaPreviousMonthText + ' ' + ariaDisabledText;
    const nextMonthText = allowNext ? ariaNextMonthText : ariaNextMonthText + ' ' + ariaDisabledText;

    this.$.prevArrow.setAttribute('aria-label', prevMonthText);
    this.$.nextArrow.setAttribute('aria-label', nextMonthText);
  }

  /**
   * @desc set past/inactive days to disabled state
   * @param {String} date, ex: 2017-10-20
   * @param {String} start date, ex: 2017-10-20
   * @param {Boolean} if only slotted content is enabled
   * @param {Boolean} if selection for all dates should be disabled
   * @param {Boolean} if disabled can be focused
   * @return {Boolean}
   */
  _isDefaultDateDisabled(date, startDate, endDate, availableUntilEndDate, onlyEnableSlotted, disableSelection, allowDisabledFocus) {
    return onlyEnableSlotted ||
      this.isPastDate(date, startDate) ||
      (availableUntilEndDate && this.isPastDate(endDate, date)) ||
      (disableSelection && !allowDisabledFocus);
  }

  /**
   * @desc add a css class if it's the first or last day of the calendar if they are not in the displayed month
   * (previous or next month)
   * @param {Object} month data item
   * @return {String} css class
   */
  _getBlankClass(selectedDates, selectableEndDate, monthDataItem) {
    let cssClass = 'blank';

    if (monthDataItem.first) {
      cssClass += ' first';
    }
    if (monthDataItem.last) {
      cssClass += ' last';
    }

    if (monthDataItem.lastRow) {
      cssClass += ' lastRow';
    }
    if (monthDataItem.lastWeekday) {
      cssClass += ' lastWeekday';
    }
    if (monthDataItem.firstWeekday) {
      cssClass += ' firstWeekday';
    }

    let startDate = selectedDates && selectedDates.length > 0 ? selectedDates[0] : '';
    let endDate = selectableEndDate;

    let enableFuse = this._shouldEnableFuse();
    if (this._shouldSetFuseStartAndEndDate(enableFuse, startDate)) {
      startDate = this.fuseDates.start;
      endDate = this.fuseDates.end;
    }

    if (
      monthDataItem.adjacentValue
      && (selectedDates
      && selectableEndDate
      && selectedDates.length > 0
      && this.maxAllowed > 1
      || (enableFuse))
      && (
        monthDataItem.lastRow
        && monthDataItem.adjacentValue >= startDate
        && monthDataItem.adjacentValue < endDate
        ||
        monthDataItem.firstRow
        && monthDataItem.adjacentValue <= endDate
        && monthDataItem.adjacentValue > startDate
      )
    ) {

      cssClass += ' highlight';
    }
    return cssClass;
  }

  _getDateClass(monthDataItem) {
    let cssClass = 'day';

    if (monthDataItem.lastRow) {
      cssClass += ' lastRow';
    }
    if (monthDataItem.lastWeekday) {
      cssClass += ' lastWeekday';
    }
    if (monthDataItem.firstWeekday) {
      cssClass += ' firstWeekday';
    }

    return cssClass;
  }

  /**
   * @desc check if we should show navigation arrows
   * @param {String} navigation
   * @return {Boolean}
   */
  _hasNavigation(navigation) {
    return navigation !== 'none';
  }

  /**
   * @desc check if we should show navigation arrows
   * @param {String} navigation
   * @return {Boolean}
   */
  _hasNavigationArrows(navigation) {
    return ['tap', 'swipe-and-tap'].indexOf(navigation) !== -1;
  }

  /**
   * @desc check if we should show navigation arrows
   * @param {String} navigation
   * @return {Boolean}
   */
  _hasNavigationSwipe(navigation) {
    return ['swipe', 'swipe-and-tap'].indexOf(navigation) !== -1;
  }

  /**
   * @desc similar to navigation arrows, determine if prev/next months are visible
   * @param {Date} currentDate
   * @param {String} startDate, ex: 2017-10-01
   * @param {String} endDate, ex: 2017-12-31
   * @param {Number} offset, ie: -1 is previous month, 1 is next month
   * @param {Boolean} disable navigation
   * @return {Boolean}
   */
  _isVisible(currentDate, startDate, endDate, offset, disableNavigation, disablePrevArrow, disableNextArrow) {
    if (offset === -1) return this._allowPrev(currentDate, startDate, disableNavigation, disablePrevArrow);
    if (offset === 1) return this._allowNext(currentDate, endDate, disableNavigation, disableNextArrow);
    return true;
  }

  /**
   * @desc adjust size of each month - used for swipe navigation
   * The current month needs to sit inside the month viewport and allow space to see surrounding month slivers.
   * @param {String} navigation
   * @param {Boolean} slivers
   */
  _resizeMonths(navigation, slivers) {
    afterNextRender(this, () => {
      this._calculateMonthWidth(navigation, slivers);
    });
  }

  /**
   * @desc Calculate the width of each month view
   * @param {String} navigation
   * @param {Boolean} slivers
   */
  _calculateMonthWidth(navigation, slivers) {
    let months = this.shadowRoot.querySelectorAll('.monthWrapper');

    if (!this._hasNavigationSwipe(navigation)) {
      months.forEach((month) => {
        month.style.width = 'auto';
      });
    } else {
      let monthWidth = this._getMonthWidth(navigation, slivers);
      months.forEach((month) => {
        month.style.width = monthWidth + 'px';
      });

      // there are three months in the swipe presentation
      // previous, current, next
      // offset the viewport to current month
      // when showing arrows + swipe nav, the slivers are not shown, so offset is different
      let offset = slivers ? 10 : -11;
      this.$.months.style.left = -(monthWidth - offset) + 'px';
    }
  }

  /**
   * @desc get the width of a month - used for swipe navigation
   * @param {String} navigation
   * @param {Boolean} slivers
   * @return {Number} width
   */
  _getMonthWidth(navigation, slivers) {
    // get width of calendar/container
    let calendarWidth = this.getBoundingClientRect().width;

    // leave space to ensure we can see the surrounding months (space defined by redlines)
    let widthOfSliver = 14;
    let marginBetweenMonths = 7;

    let monthWidth = calendarWidth;
    // 2 x (times) because there are two surrounding months
    if (this.slivers) {
      monthWidth -= 2 * (widthOfSliver + marginBetweenMonths);
    }
    return monthWidth;
  }

  /**
   * @desc get an array of dates/slots
   * @return {Array} days
   */
  _getDays() {
    let slots = this.shadowRoot.querySelectorAll('slot.date');
    slots =  Array.prototype.slice.call(slots);
    let days = [];
    slots.forEach(slot => {
      let day = slot.assignedNodes({flatten:true})
        .filter(n => n.nodeType === Node.ELEMENT_NODE)[0];
      days.push(day);
    });
    return days;
  }

  /**
   * @desc check if consumer provided end message
   * @param {String} currentDate -- used to trigger check
   */
  _checkHasEndMessage(currentDate) {
    // using before next render because we need to wait for a dom-if before doing this check
    beforeNextRender(this, () => {
      let slot = this.shadowRoot.querySelector('slot[name="endMessage"]');
      if (!slot) return;
      let nodes = slot.assignedNodes();
      this._hasEndMessage = nodes.length > 0;
    });
  }

  /**
   * @desc check if end message is shown
   * @param {String} currentDate
   * @param {String} endDate
   * @param {Number} offset
   * @param {Boolean} has end message slotted content
   * @return {Boolean}
   */
  _showEndMessage(currentDate, endDate, offset, _hasEndMessage) {
    if (!currentDate || !endDate || !_hasEndMessage) return false;
    const showEndMessage = this._isEnd(currentDate, endDate, offset);
    if (showEndMessage) {
      this._dispatchDataLoad();
    }
    return showEndMessage;
  }

  /**
   * @desc check if end of the calendar has been reached
   * @param {String} curentDate
   * @param {String} endDate
   * @param {Number} offset
   * @return {Boolean} if end month
   */
  _isEnd(currentDate, endDate, offset) {
    if (!currentDate || !endDate) return;
    let offsetDate = this._getOffsetDate(currentDate, offset);
    return offsetDate.slice(0, 7) === endDate.slice(0, 7);
  }

  /**
   * @desc get date for the months on either side (offset)
   * @param {String} curentDate
   * @param {Number} offset
   * @return {String} date, ex: 2017-12-01
   */
  _getOffsetDate(currentDate, offset) {
    let dateCopy = this.getDateObject(currentDate);
    dateCopy.setDate(1);
    dateCopy.setMonth(dateCopy.getMonth() + offset);
    return this.getStringFromDate(dateCopy);
  }

  /**
   * @desc move focus of wdat-elements based on directional key presses
   * @param {Event} event
   * @param {Number} days
   */
  _moveFocus(event, days) {
    // determine the initially focused element
    // get all slots or wdat-elements
    let daysArray = this._getDays();
    if (!daysArray.length) return;

    let focusedDate = daysArray.filter(day => day.focused);

    // if there is no focused date, set focus on the first available date of the month
    if (!focusedDate.length) {
      let firstAvailDates = daysArray.filter(day => day.disabled === false || (this.allowDisabledFocus && !day.past));
      if (!firstAvailDates.length) return;
      this._setFocus(daysArray, firstAvailDates[0].date);
      return;
    }

    let focusedMonth = this.getDateObject(focusedDate[0].date).getMonth();
    let focusedYear = this.getDateObject(focusedDate[0].date).getFullYear();
    let nextFocusedDate = this.getDateObject(focusedDate[0].date);
    let monthChanged = false;

    //for up/down keys it's +-7 for left/right keys it's +-1
    nextFocusedDate.setDate(nextFocusedDate.getDate() + days);
    let nextFocusedDateString = this.getStringFromDate(nextFocusedDate);
    let nextFocusedMonth = nextFocusedDate.getMonth();
    let nextFocusedYear = nextFocusedDate.getFullYear();

    if (focusedMonth < nextFocusedMonth && this.navigation !== 'none') {
      monthChanged = true;
      if (focusedYear == nextFocusedYear) {
        this._nextHandler(event);
      } else {
        this._prevHandler(event);
      }
    } else if (focusedMonth > nextFocusedMonth && this.navigation !== 'none') {
      monthChanged = true;
      if (focusedYear == nextFocusedYear) {
        this._prevHandler(event);
      } else {
        this._nextHandler(event);
      }
    }
    afterNextRender(this, () => {
      daysArray = this._getDays();
      this._setFocus(daysArray, nextFocusedDateString, monthChanged);
    });
  }

  /**
   * @desc aria label for date
   * @param {Object} date Element
   * @param {String} locale
   * @return {String} label
   */
  _getDateLabel(date, locale) {
    let ariaDate = this.getDateObject(date.date),
      options =  {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      },
      label,
      multidayAdditionalLabel;

    if (locale) {
      label = ariaDate.toLocaleString(locale, options);
      let additionalLabel = '';
      if (date.disabled === true) {
        additionalLabel = this.ariaContent.dateDisabled;
      }
      if (date.disabled === true && date.class === 'none' && this.enableNavToDisabledDates){
        additionalLabel = this.ariaContent.blockedOut;
      }
      if (date.disabled === true && date.class === 'noInfo' && this.enableNavToPastDates){
        additionalLabel = this.ariaContent.noInformationAvailable;
      }
      if (typeof additionalLabel !== 'undefined') {
        label = label + ' ' + additionalLabel;
      }
      if (date.selected) {
        // setting the aria-label according to the selected date range
        if (this.selectedDates && !this._isSingleDayMode()) {
          let selectedLabel = COMUtils.replaceTokenKeys(['[selectedDates]', '[maxAllowed]'],
                              [this.selectedDates.length, this.maxAllowed],
                              this.ariaContent.selectedParkDays);

          label = selectedLabel + ' ' + label;
          if (date.date === this.selectedDates[0] && this.selectedDates.length < this.maxAllowed) {
            // First date for the range is the next day of the first selected date
            let ariaFirstDate = this.getDateObject(this.selectedDates[0]);
            ariaFirstDate.setDate(ariaFirstDate.getDate() + 1);
            let ariaFirstDateString = ariaFirstDate.toLocaleString(locale, options)
            let ariaLastDate = this.getDateObject(this.selectableEndDate).toLocaleString(locale, options);
            let pendingDays = this.maxAllowed - this.selectedDates.length;

            multidayAdditionalLabel = COMUtils.replaceTokenKeys(['[pendingDays]', '[ariaFirstDate]', '[ariaLastDate]'],
                                      [pendingDays, ariaFirstDateString, ariaLastDate],
                                      this.ariaContent.youCanSelect);
          }
        } else {
          label = this.ariaContent.dateSelected + ' ' + label;
        }
      }
    }

    let defaultText = !date.past && this.ariaContent.dateDefault,
      additional = date.additionalAriaLabel || defaultText;

    if ((!date.selected || !this.disableAdditionalAriaDateLabel) && date.class !== 'noInfo' && additional) {
      label += ' ' + additional;
    }

    if (multidayAdditionalLabel) label += '. ' + multidayAdditionalLabel;

    if (!date.selected &&
        date.classList.contains('selectable') &&
        !this._isSingleDayMode() &&
        this.selectedDates &&
        this.selectedDates.length >= this.maxAllowed) {
      label += '. ' + 'Maximum number of days selected, to select another day, first unselect a previous selection.';
    }

    return label;
  }

  /**
   * @desc set focus for com-calendar-date element
   * @param {Array} daysArray
   * @param {String} dateString
   * @param {Boolean} monthChanged
   */
  _setFocus(daysArray, dateString, monthChanged) {
    daysArray = daysArray.filter(day => day.date === dateString);
    // check to see if date is disabled
    // if the month hasn't changed, set focus,
    // if months has changed, set focus on the first available date of the month
    if (daysArray[0] !== undefined) {
      if (!daysArray[0].disabled || (this.allowDisabledFocus && !daysArray[0].past) || (((daysArray[0].class === 'none' || daysArray[0].class === 'unavailable' || daysArray[0].class === 'blocked') && this.enableNavToDisabledDates) ||
           (daysArray[0].class === 'noInfo' && this.enableNavToPastDates))) {
        daysArray[0].focus();
      } else if (daysArray[0].disabled && monthChanged === true) {
        let availDates = this._getDays().filter(day => day.disabled === false);
        availDates[0].focus();
      }
    }
  }

  /**
   * @desc right arrow key handler
   * @param {Event} e
   */
  _nextDay(e) {
    e.detail.keyboardEvent.preventDefault();
    this._moveFocus(e, 1);
  }

  /**
   * @desc left arrow key handler
   * @param {Event} e
   */
  _prevDay(e) {
    e.detail.keyboardEvent.preventDefault();
    this._moveFocus(e, -1);
  }

  /**
   * @desc down arrow key handler
   * @param {Event} e
   */
  _nextWeek(e) {
    e.detail.keyboardEvent.preventDefault();
    this._moveFocus(e, 7);
  }

  /**
   * @desc up arrow key handler
   * @param {Event} e
   */
  _prevWeek(e) {
    e.detail.keyboardEvent.preventDefault();
    this._moveFocus(e, -7);
  }

  /**
   * @desc calculate an unique ID based on offet
   * @param {String} name
   * @param {Number} offset
   */
  _calculateId(name, offset) {
    return name + '-' + offset;
  }

  /**
   * @desc calculate the number of rows in calendar
   * @param {String} currentDate
   * @param {String} navigation
   * @return {Object} row info
   */
  _getNumberOfDateRows(currentDate, navigation) {

    if (!currentDate || !navigation) return;

    let all = [],
      current,
      max,
      offsets = this._getMonthOffsets(navigation),
      endDateMonth = this.getDateObject(this.endDate).getMonth();

    offsets.forEach(offset => {

      let monthCopy = this.getDateObject(currentDate);
      monthCopy.setDate(1);
      monthCopy.setMonth(monthCopy.getMonth() + offset);

      // Ignore end month row count
      if (offset === 1 && monthCopy.getMonth() === endDateMonth) {
        return;
      }

      // set leading dates from previous month
      let firstDay = this._getFirstDay(monthCopy);
      let numDays = this._getNumberOfDays(monthCopy);
      let numRows =  Math.ceil((firstDay + numDays) / 7);

      if (offset === 0) {
        current = numRows;
      }
      all.push(numRows);
    });

    return {
      rows: current,
      max: all.reduce((a, b) => Math.max(a, b))
    };
  }

  /**
   * @desc Aggreate status for the drawer based on external config, single/multi day mode
   * its presence on DOM and calendar id.
   *
   * @return {Boolean} true if the drawer is enabled
   */
  _isDrawerEnabled() {
    return this.drawerEnable && this._isSingleDayMode() && this.$.drawer && this.id.includes('0');
  }

  /**
   * @desc animate drawer
   * @param {Number} current row info
   * @param {Number} previous row info
   */
  _moveDrawer(current, previous) {
    if (!this._isDrawerEnabled()) { return; }

    // determine if drawer should be moved up (negative margin)
    let drawerUp = current.rows < current.max;
    if (drawerUp) {
      this.$.drawer.classList.add('drawer-up');
    } else {
      this.$.drawer.classList.remove('drawer-up');
    }

    // check to see if we should continue to animate movement
    if (!previous) return;
    if (current.rows === previous.rows) return;

    // determine direction of motion of drawer
    let animateClass = current.rows < previous.rows ? 'drawer-move-up' : 'drawer-move-down';
    let removeAnimation = () => {
      this.$.drawer.classList.remove(animateClass);
      this.$.drawer.removeEventListener('animationend', removeAnimation);
    };
    this.$.drawer.addEventListener('animationend', removeAnimation);
    // only animate if the drawer is already opened
    if (this.$.drawer.open) {
      this.$.drawer.classList.add(animateClass);
    }
  }

  /**
   * @desc Check if drawer stay open
   * @return {Boolean}
   */
  _shouldDrawerStayOpen() {
    // TODO: check if we need to compare year as well here.
    let isCurrentMonthEndMonth = this.getDateObject(this.currentDate).getMonth() === this.getDateObject(this.endDate).getMonth();
    return (this.selectedDates && this.selectedDates.length > 0) && !isCurrentMonthEndMonth;
  }
  /**
   * @desc Change drawer state
   * @param {Array} selectedDates
   * @return {Boolean}
   */
  _changeDrawerState(selectedDates) {
    // Check if selectedDates length is 1 because the drawer
    // only gets displayed for 1 day calendar
    if (this.$.drawer && selectedDates && selectedDates.length === 1) {
      // Android is having trouble focusing, we are refocusing and
      // then focusing the drawer
      this.$.refocus.focus();
      timeOut.run(() => { this.$.drawer.focus(); }, 0);
    }
  }
}
window.customElements.define(COMCalendarBase.is, COMCalendarBase);
